import React,{useEffect,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import API from '../utils/api';

const STATUS={
  pending:['待审核','#d97706','#fff7ed'],
  approved:['已通过','#15803d','#f0fdf4'],
  rejected:['已拒绝','#b91c1c','#fef2f2']
};

export default function DeliveryReview(){
  const nav=useNavigate();
  const [rows,setRows]=useState([]);
  const [tab,setTab]=useState('pending');
  const [loading,setLoading]=useState(true);
  const [busy,setBusy]=useState(null);

  const load=async(status=tab)=>{
    setLoading(true);
    try{
      const r=await API.get(
        '/delivery/registration-requests',
        {params:{status}}
      );
      setRows(r.data||[]);
    }catch(e){
      alert(e.response?.data?.message||'读取人员审核列表失败');
    }finally{
      setLoading(false);
    }
  };

  useEffect(()=>{
    load(tab);
  },[tab]);

  const review=async(row,decision)=>{
    if(busy)return;

    let review_note='';

    if(decision==='approved'){
      if(!window.confirm(
        `确认审核通过？\n\n${row.real_name} · ${row.person_category}\n${row.phone_masked}\n\n通过后将启用该人员账号。`
      ))return;
    }else{
      review_note=window.prompt(
        '请输入拒绝原因',
        '资料需要进一步核实'
      );

      if(review_note===null)return;
      review_note=review_note.trim();

      if(!review_note){
        alert('请填写拒绝原因');
        return;
      }
    }

    setBusy(row.id);

    try{
      const r=await API.post(
        `/delivery/registration-requests/${row.id}/review`,
        {
          decision,
          review_note
        }
      );

      alert(r.data?.message||'审核完成');
      await load(tab);

    }catch(e){
      alert(e.response?.data?.message||'审核失败');
    }finally{
      setBusy(null);
    }
  };

  return(
    <div style={s.page}>
      <header style={s.header}>
        <button style={s.back} onClick={()=>nav('/')}>← 返回</button>
        <div>
          <div style={s.title}>👤 人员审核</div>
          <div style={s.sub}>外卖 · 快递 · 装修工实名审核</div>
        </div>
      </header>

      <div style={s.notice}>
        注册人员必须核对身份证照片与本人正脸。
        审核通过后账号生效；门禁权限另行授权。
      </div>

      <div style={s.tabs}>
        <Tab
          active={tab==='pending'}
          onClick={()=>setTab('pending')}
          text="待审核"
        />
        <Tab
          active={tab==='approved'}
          onClick={()=>setTab('approved')}
          text="已通过"
        />
        <Tab
          active={tab==='rejected'}
          onClick={()=>setTab('rejected')}
          text="已拒绝"
        />
      </div>

      <main style={s.body}>
        {loading ? (
          <div style={s.empty}>正在读取...</div>
        ) : !rows.length ? (
          <div style={s.empty}>
            {tab==='pending'?'暂无待审核人员':'暂无记录'}
          </div>
        ) : (
          rows.map(row=>(
            <ReviewCard
              key={row.id}
              row={row}
              busy={busy===row.id}
              review={review}
            />
          ))
        )}
      </main>
    </div>
  );
}

function Tab({active,onClick,text}){
  return(
    <button
      onClick={onClick}
      style={{
        ...s.tab,
        ...(active?s.tabActive:{})
      }}
    >
      {text}
    </button>
  );
}

function ReviewCard({row,busy,review}){
  const status=STATUS[row.status]||[
    row.status,
    '#555',
    '#f5f5f5'
  ];

  return(
    <section style={s.card}>
      <div style={s.cardTop}>
        <div>
          <div style={s.name}>
            {categoryIcon(row.person_category)}
            {' '}
            {row.real_name}
          </div>

          <div style={s.meta}>
            {row.person_category}
            {row.delivery_platform
              ? ` · ${row.delivery_platform}`
              : ''}
          </div>
        </div>

        <span
          style={{
            ...s.status,
            color:status[1],
            background:status[2]
          }}
        >
          {status[0]}
        </span>
      </div>

      <div style={s.infoGrid}>
        <Info label="手机号码" value={row.phone_masked||'-'} />
        <Info label="身份证" value={row.id_card_masked||'-'} />
        <Info label="申请时间" value={fmt(row.created_at)} />
        {row.reviewed_at
          ? <Info label="审核时间" value={fmt(row.reviewed_at)} />
          : null}
      </div>

      <div style={s.photoTitle}>实名照片核验</div>

      <div style={s.photos}>
        <Photo
          title="身份证照片"
          src={row.id_card_photo}
        />
        <Photo
          title="本人正脸"
          src={row.face_photo}
        />
      </div>

      {row.review_note ? (
        <div style={s.note}>
          审核备注：{row.review_note}
        </div>
      ) : null}

      {row.reviewer_name ? (
        <div style={s.reviewer}>
          审核人：{row.reviewer_name}
        </div>
      ) : null}

      {row.status==='pending' ? (
        <div style={s.actions}>
          <button
            disabled={busy}
            style={{
              ...s.approve,
              opacity:busy?.55:1
            }}
            onClick={()=>review(row,'approved')}
          >
            {busy?'处理中...':'✓ 审核通过'}
          </button>

          <button
            disabled={busy}
            style={{
              ...s.reject,
              opacity:busy?.55:1
            }}
            onClick={()=>review(row,'rejected')}
          >
            ✕ 拒绝
          </button>
        </div>
      ) : null}
    </section>
  );
}

function Info({label,value}){
  return(
    <div style={s.info}>
      <div style={s.infoLabel}>{label}</div>
      <div style={s.infoValue}>{value}</div>
    </div>
  );
}

function Photo({title,src}){
  return(
    <div style={s.photoBox}>
      <div style={s.photoLabel}>{title}</div>

      {src ? (
        <a
          href={src}
          target="_blank"
          rel="noreferrer"
          style={s.photoLink}
        >
          <img
            src={src}
            alt={title}
            style={s.photo}
          />
          <div style={s.zoom}>点击查看大图</div>
        </a>
      ) : (
        <div style={s.noPhoto}>无照片</div>
      )}
    </div>
  );
}

function categoryIcon(v){
  if(v==='外卖')return '🍱';
  if(v==='快递')return '📦';
  if(v==='装修工')return '🛠️';
  return '👤';
}

function fmt(v){
  if(!v)return '-';

  try{
    return new Date(v).toLocaleString('zh-CN',{
      hour12:false
    });
  }catch(_){
    return String(v);
  }
}

const s={
  page:{
    minHeight:'100vh',
    background:'#f4f6f9',
    paddingBottom:85
  },

  header:{
    display:'flex',
    alignItems:'center',
    gap:12,
    padding:'18px 16px',
    background:'#173f73',
    color:'#fff'
  },

  back:{
    border:'1px solid rgba(255,255,255,.4)',
    background:'rgba(255,255,255,.12)',
    color:'#fff',
    borderRadius:8,
    padding:'8px 10px'
  },

  title:{
    fontSize:20,
    fontWeight:800
  },

  sub:{
    fontSize:12,
    opacity:.82,
    marginTop:3
  },

  notice:{
    margin:'12px 12px 0',
    padding:'11px 13px',
    background:'#fff8e8',
    color:'#7c5310',
    border:'1px solid #f0ddb5',
    borderRadius:10,
    fontSize:13,
    lineHeight:1.65
  },

  tabs:{
    display:'flex',
    gap:8,
    padding:'12px 12px 4px'
  },

  tab:{
    flex:1,
    border:'1px solid #d9dee7',
    background:'#fff',
    color:'#555',
    borderRadius:9,
    padding:'10px 4px',
    fontWeight:700
  },

  tabActive:{
    background:'#173f73',
    color:'#fff',
    borderColor:'#173f73'
  },

  body:{
    padding:12
  },

  card:{
    background:'#fff',
    borderRadius:13,
    padding:14,
    marginBottom:12,
    boxShadow:'0 2px 10px rgba(0,0,0,.06)'
  },

  cardTop:{
    display:'flex',
    justifyContent:'space-between',
    gap:10,
    alignItems:'flex-start'
  },

  name:{
    fontSize:18,
    fontWeight:800,
    color:'#1d2733'
  },

  meta:{
    fontSize:13,
    color:'#777',
    marginTop:5
  },

  status:{
    padding:'5px 9px',
    borderRadius:20,
    fontSize:12,
    fontWeight:800,
    whiteSpace:'nowrap'
  },

  infoGrid:{
    display:'grid',
    gridTemplateColumns:'1fr 1fr',
    gap:8,
    marginTop:14
  },

  info:{
    background:'#f7f8fa',
    borderRadius:8,
    padding:'9px 10px',
    minWidth:0
  },

  infoLabel:{
    fontSize:11,
    color:'#999'
  },

  infoValue:{
    marginTop:3,
    fontSize:13,
    color:'#333',
    wordBreak:'break-all'
  },

  photoTitle:{
    fontSize:14,
    fontWeight:800,
    marginTop:16,
    marginBottom:8,
    color:'#333'
  },

  photos:{
    display:'grid',
    gridTemplateColumns:'1fr 1fr',
    gap:10
  },

  photoBox:{
    minWidth:0
  },

  photoLabel:{
    fontSize:12,
    color:'#666',
    marginBottom:5
  },

  photoLink:{
    textDecoration:'none',
    color:'#666'
  },

  photo:{
    display:'block',
    width:'100%',
    height:190,
    objectFit:'cover',
    borderRadius:9,
    background:'#eee',
    border:'1px solid #e5e5e5'
  },

  zoom:{
    textAlign:'center',
    fontSize:11,
    marginTop:4,
    color:'#607d9f'
  },

  noPhoto:{
    height:190,
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    background:'#f5f5f5',
    borderRadius:9,
    color:'#aaa'
  },

  note:{
    marginTop:12,
    padding:10,
    background:'#f7f8fa',
    borderRadius:8,
    fontSize:13,
    color:'#555'
  },

  reviewer:{
    marginTop:8,
    fontSize:12,
    color:'#888'
  },

  actions:{
    display:'grid',
    gridTemplateColumns:'2fr 1fr',
    gap:9,
    marginTop:15
  },

  approve:{
    border:0,
    borderRadius:9,
    padding:'12px 8px',
    background:'#16834b',
    color:'#fff',
    fontWeight:800,
    fontSize:15
  },

  reject:{
    border:0,
    borderRadius:9,
    padding:'12px 8px',
    background:'#c83d3d',
    color:'#fff',
    fontWeight:800,
    fontSize:15
  },

  empty:{
    background:'#fff',
    padding:35,
    textAlign:'center',
    color:'#999',
    borderRadius:12
  }
};
